module.exports = __webpack_public_path__ + "img/about_us3.594f1a45.png";